import clsx from "clsx";
import { SingleDesignation } from "react-migration/domains/constraints/typings/applicationTypes/SingleDesignation";
import { DesignationSubTitleComponent } from "react-migration/layouts/designations/Designation";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import isString from "lodash/isString";

const getEnvironmentalPermitDate = (designation: SingleDesignation) => {
  const attribute = designation.designation_attributes.find((a) => a.key === "application_submission_date");

  if (!attribute?.value) {
    return null;
  }

  return new Date(attribute.value).toLocaleDateString();
};

export const EnvironmentalPermitsListSubTitle: DesignationSubTitleComponent = ({ designation, truncate = false }) => {
  const { t } = useTranslation();
  const categoryOrDefault = (designation: SingleDesignation) =>
    designation.sub_category?.display_name ?? t("domains.constraints.unknown");

  const date = getEnvironmentalPermitDate(designation);

  const value = [designation.display_name && categoryOrDefault(designation), designation.source.authority.name, date]
    .filter(isString)
    .join(", ");

  return (
    <div className={clsx("text-neutral-500", { truncate: truncate })} title={value}>
      {value}
    </div>
  );
};
